import { render, staticRenderFns } from "./AmountBadge.vue?vue&type=template&id=0020ba31&scoped=true&"
import script from "./AmountBadge.vue?vue&type=script&lang=js&"
export * from "./AmountBadge.vue?vue&type=script&lang=js&"
import style0 from "./AmountBadge.vue?vue&type=style&index=0&id=0020ba31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020ba31",
  null
  
)

export default component.exports